module.exports = "#logo {\n  display: inline-block;\n  height: 105px;\n  width: 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n.location-container {\n  margin-bottom: 20px;\n}\n.location-container .location {\n  text-align: center;\n  font-weight: bold;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/landing/landing.component.less
// module id = 532
// module chunks = 0